import { createSelector } from 'reselect'

export const getSubscriptionCurrentOfferSelector = createSelector(
    state => state.data.config,
    config => {

        return config ? config.subscriptionOfferDetails : {}
    }
)